import { ReactNode } from 'react';
import { NairaSymbol } from '../../../utils/mappings';

const TermsAndConditions = ({ children }: { children?: ReactNode }) => {
  return (
    <div className='row justify-content-center'>
      <div className='col-md-12 col-lg-12 col-xl-10 p-5 content-section'>
        <div>
          <h4 className='text-center'>PHARMACY SERVICES</h4>
          <h5 className='text-center'>TERMS AND CONDITIONS</h5>
          <div className='text-center'>LAST REVISED ON: 04 JUNE 2025</div>
        </div>
        <section className='mt-5'>
          <h5 className=''>ACCEPTANCE OF TERMS & CONDITIONS</h5>
          <h6 className='mt-4'>(a) Introduction:</h6>
          <p>
            These terms and conditions, together with any documents they expressly incorporate by
            reference (collectively, these “Terms”) govern all pharmacy services with WellaHealth
            Technologies Limited, access and use of{' '}
            <a href='https://engage.app.wellahealth.com/'>https://engage.app.wellahealth.com/</a> or
            its subdomains or mobile application (the “WellaPartner App”), including any content,
            component, functionality, additional terms and conditions and policies referenced herein
            and/or available by hyperlink, and/or service offered on or through Website or
            WellaPartner App (collectively and together with Website and WellaPartner App, the
            “Platform”) owned or controlled by WellaHealth Technologies Limited (“WellaHealth” or
            “WellaHealth” or “we” or “our” or “us”), as a registered pharmacy on the Platform. All
            reference to “you” or “your,” as applicable, means the Pharmacy and its affiliates and
            their respective directors, officers, employees, and agents.
          </p>

          <h6 className='mt-4'>(b) Acceptance of these Terms:</h6>
          <p>
            By registering, accessing, or using the Platform, using or downloading the Wella Partner
            App, you indicate your acceptance of the Terms on your behalf and on behalf of the
            Pharmacy you represent. You also understand and accept that WellaHealth shall be using
            the account payment channel (“payment channel”) on the Platform/ the website (as may be
            applicable) to fund your wallet on the platform/website (“WellaPartner wallet”). Please
            read these Terms of Service carefully.
          </p>
          <h6 className='mt-4'>(c) Your Duty to Regularly Review these Terms:</h6>
          <p>
            Your use of the Platform is governed by the version of the Terms in effect on the date
            the Platform is accessed by you. WellaHealth reserves the right to update, modify,
            change or replace any part of these Terms at any time and without prior notice. It is
            your responsibility to check the Platform periodically for changes to these Terms.
          </p>
        </section>
        <section className='mt-5'>
          <h5>GENERAL</h5>
          <p>
            (a) To access or use some of the features on the Platform, you will be required to log
            in to and create an account (your “Account”) or the WellaPartner App. You will be able
            to change your password at the time of registration (after we have sent you a sms
            notification with a randomly generated initial password). You are responsible for
            ensuring the safety of your Account.
          </p>
          <p>
            (b) The Platform's rules governing any resulting collection and use of your information
            are disclosed in our Privacy Policy.
          </p>
          <p>
            (c) The Platform may include or make available to you, certain content (the “Content”),
            which includes, without limitation: drug orders, consultation requests, account
            positions, balances, transactions, confirmations, and order history.
          </p>
          <p>
            (d) We shall notify your account of a request for direct face-to-face pharmacist
            consultation and/or drug orders by a subscriber on the Platform (a “Subscriber”) for
            immediate action. Our referrals are made to pharmacies on the Platform based on
            proximity, availability of standard equipment and professionals, and quality of service.
          </p>
          <p>
            (e) To sign up on the Platform, you must be duly registered with the Corporate Affairs
            Commission (CAC) and the Pharmacist Council of Nigeria (PCN) to provide pharmaceutical
            services. You represent and warrant that you are duly registered, and have obtained all
            the relevant licenses/permits required to operate a pharmacy in Nigeria. You also
            represent that you are willing, and able to provide affordable and quality
            pharmaceutical service.
            <p className='mt-3 fw-700'>
              Before you are added to our Network of Pharmacies, you will be required to provide
              scanned copies of your incorporation certificate, PCN licence, and any other documents
              that we may require from you.
            </p>
          </p>
          <p>
            (f) By signing up, you agree to deliver your pharmaceutical services on the Platform in
            compliance with the conditions stated in the Terms of Service.
          </p>
          <p>
            (g) A breach or violation of any of these Terms will result in an immediate termination
            of your partnership with WellaHealth.
          </p>
        </section>
        <section className='mt-5'>
          <h5>PATIENT PICK-UPS</h5>
          <p>
            Pick up codes verification unlocks payment Patients now have to present a code at the
          </p>
          <p> pharmacy before collecting their prescribed medications.</p>
          <p>
            (a) Pharmacies are mandated to collect pick up codes from patients and verify on the
            Wellapartner app before dispensing.
          </p>
          <p>
            (b) Entering pick up codes on the app signifies that medications have been given to the
            patient, Only afterwards is the amount credited for those medications withdrawable from
            the wallet.
          </p>
          <p>
            (c) Wallet credits will be reversed between 3 to 10 days depending on the HMO, so codes
            must be verified before meds are dispensed
          </p>
          <p>
            (d) Wellahealth will not be mandated to pay for any medications dispensed without codes.
          </p>
        </section>
        <section className='mt-5'>
          <h5>MONTHLY SUSBCRIPTIONS</h5>
          <p>
            Pharmacies who receive medication requests via the Wellahealth platform are to pay a
            subscription fee whenever the value of transactions reach certain thresholds.
          </p>
          <p>
            {NairaSymbol}15,000 to {NairaSymbol}50,000 : {NairaSymbol}1,000
          </p>
          <p>
            Above {NairaSymbol}50,000 : {NairaSymbol}2,500
          </p>
          <div style={{ lineBreak: 'anywhere' }}>
            If you have any questions about these Terms, please contact us at
            <a className='mx-2' href='mailto:contact@wellahealth.com'>
              contact@wellahealth.com
            </a>
            or
            <a className='mx-2' href='mailto:medicalops@wellahealth.com'>
              medicalops@wellahealth.com
            </a>
          </div>
        </section>
        {children && <div>{children}</div>}
      </div>
    </div>
  );
};
export default TermsAndConditions;
